"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BURN_REDEEM_721_V2_ABI_json_1 = tslib_1.__importDefault(require("../abis/burnredeem/BURN_REDEEM_721_V2_ABI.json"));
const BURN_REDEEM_721_V3_ABI_json_1 = tslib_1.__importDefault(require("../abis/burnredeem/BURN_REDEEM_721_V3_ABI.json"));
const ContractVersion_1 = require("./ContractVersion");
class BurnRedeem721Version extends ContractVersion_1.ContractVersion {
    constructor() {
        super(...arguments);
        // @dev: the latest current version
        this.version = "v3.1";
        this.deployedContractsByVersion = {
            "v2.0": {
                goerliAddress: "0x2d7F13F594624170e30eE81d2b7E86c5Ebc3Df60",
                mainnetAddress: "0x23A553a150Ab2f5f88C01C0449b672d9f7EFEB36",
                abi: BURN_REDEEM_721_V2_ABI_json_1.default,
            },
            "v3.0": {
                goerliAddress: "0x264a4611403B9C331D72603F7dEE5B3bFf0047cD",
                mainnetAddress: "0x20847F61e494e72D55d32A542C519e27D229Aedb",
                abi: BURN_REDEEM_721_V3_ABI_json_1.default,
            },
            "v3.1": {
                goerliAddress: "0x1aEbd9fB121F33C37Bbc6054cA50862249A39f66",
                mainnetAddress: "0xd391032fec8877953C51399C7c77fBcc93eE3E2A",
                abi: BURN_REDEEM_721_V3_ABI_json_1.default,
            },
        };
    }
}
exports.default = new BurnRedeem721Version();
//# sourceMappingURL=BurnRedeem721Version.js.map